<!-- product-box slider -->
<section *ngIf="products.length <= 0 && !loading">
    <div class="full-box">
        <div class="container-fluid">
            <div class="col-sm-12 empty-cart-cls text-center resultados">
                 <h3><strong>{{'product-empty' | translate}}</strong></h3>               
            </div>
        </div>
    </div>
</section>

<section *ngIf="products.length > 0 && !loading">
    <div class="full-box">
        <div class="container-fluid">                
            <!--desktop-->
            <div class="flex-container on-mobile">
                <div class="flex-item" *ngFor="let product of products">
                    <div class="theme-card center-align">
                        <div class="offer-slider">
                            <div class="sec-1">
                                <div class="product-box2">
                                    <app-product-card [product]="product"></app-product-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-pagination">
                <div class="theme-paggination-block">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col-md-12">
                                <nav aria-label="Page navigation">
                                    <ul class="pagination">
                                        <li class="page-item"
                                            [ngClass]="{'disabled': page === 1 || loading, 'cursor-pointer': page > 1}">
                                            <a class="page-link" aria-label="Previous"
                                                    (click)="prev()">
                                                <span aria-hidden="true">
                                                    <i class="fa fa-chevron-left"
                                                       aria-hidden="true">

                                                    </i>
                                                </span>
                                                Anterior
                                                <span class="sr-only">Previous</span>
                                            </a>
                                        </li>     
                                        <li>
                                            <div class="product-search-count-bottom">
                                                <h5> {{ page }} - {{ cantpages }}</h5>
                                            </div>
                                        </li>                                   
                                        <li class="page-item"
                                            [ngClass]="{'disabled': lastPage() || loading, 'cursor-pointer': !lastPage()}">
                                            <a class="page-link" aria-label="Next"
                                                    (click)="next()">
                                                    Siguiente
                                                    <span aria-hidden="true">
                                                    <i class="fa fa-chevron-right"
                                                       aria-hidden="true"></i></span>
                                                       
                                                <span class="sr-only">Next</span>                                                
                                                
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- product-box slider end -->
